import classNames from 'classnames'
import { memo } from 'react'
import { FiShoppingBag } from 'react-icons/fi'
import { useGuests } from '../../../../../hooks/queries/guests/use-guests'
import type { LiveGuest } from '../../../../../types/lives/live'
import { Gifter } from './components/gifter'
import { SelectAll } from './components/select-all'
import { useGetUsersToGift } from './use-get-users-to-gift'

interface Props {
  isPackageSelected: boolean
  handleTogglePackageSelected: () => void
}

export const Gifters = memo(
  ({ isPackageSelected, handleTogglePackageSelected }: Props) => {
    useGuests()

    const {
      checkGifters,
      typeLive,
      handleSelectUserToGift,
      //
    } = useGetUsersToGift()

    const isVideo = !typeLive?.includes('multi')

    return (
      <div className="flex flex-row mb-1 h-10 items-center bg-[#151515]">
        {!isVideo && (
          <div className="flex flex-row flex-1 gap-2 overflow-y-scroll bg-[#151515] ">
            {checkGifters?.map((gifter) => (
              <Gifter
                key={gifter.userId}
                guest={gifter as LiveGuest}
                handleSelectUserToGift={handleSelectUserToGift}
              />
            ))}
          </div>
        )}

        <div className="flex flex-row ">
          <SelectAll />

          <div
            onClick={handleTogglePackageSelected}
            className={classNames(
              'rounded-full w-10 h-10 flex justify-center items-center text-white',
              {
                'border-2 border-purple-600': isPackageSelected,
              },
            )}
          >
            <FiShoppingBag />
          </div>
        </div>
      </div>
    )
  },
)
